// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"3770e61f","131":"87c8fdff","262":"3770e61f"}[chunkId] + ".chunk.css";
};